<button
  #button
  (click)="onClickButton($event)"
  [disabled]="disabled"
  class="newest-button"
  [ngClass]="customClass"
  [ngbTooltip]="tooltip"
  [openDelay]="tooltipDelay"
  [disableTooltip]="!showTooltip"
  triggers="hover touchstart"
  tooltipClass="mb-4"
>
  <span *ngIf="loading" class="button-spinner">
    <img  class="spinner" src="assets/spinner-20-blue.svg" alt="Spinner" />
  </span>
  <span [class.hide-label]="loading">{{ label | translate }}</span>
</button>
